
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import StorySection from './components/StorySection';
import MissionSection from './components/MissionSection';
import WhyChooseUs from './components/WhyChooseUs';

export default function AboutPage() {
  useEffect(() => {
    document.title = 'About High Standards Smoke Shop - Our Story & Mission in Eustis Florida';
    window.scrollTo(0, 0);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: 'About High Standards Smoke Shop',
      description:
        'Learn about High Standards Smoke Shop in Eustis, Florida — our story, mission, and commitment to premium smoke products and exceptional service.',
      url: `${siteUrl}/about`,
      isPartOf: {
        '@type': 'WebSite',
        name: 'High Standards Smoke Shop',
        url: siteUrl,
      },
      mainEntity: {
        '@type': 'LocalBusiness',
        name: 'High Standards Smoke Shop',
        description: 'Premium smoke shop in Eustis, Florida specializing in vapes, fine glass, hookah, shisha, CBD products and curated accessories.',
        url: siteUrl,
        telephone: '+13529774832',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '1321 S Bay St',
          addressLocality: 'Eustis',
          addressRegion: 'FL',
          postalCode: '32726',
          addressCountry: 'US',
        },
        sameAs: [
          'https://www.instagram.com/highstandardsmoke?igsh=MXd0YTRobGI0MWUzZw%3D%3D',
          'https://www.tiktok.com/@highstandards.smokes',
        ],
      },
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-about';
    script.textContent = JSON.stringify(schema);
    const existing = document.getElementById('schema-about');
    if (existing) existing.remove();
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-about');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="bg-deep-black min-h-screen">
      <Navbar />
      <main>
        <AboutHero />
        <StorySection />
        <MissionSection />
        <WhyChooseUs />
      </main>
      <Footer />
    </div>
  );
}
